export default "__VITE_ASSET__7e3acc07__"